import { useStore } from 'vuex'
import { ref, onMounted } from 'vue'

export default {
    name: 'ReceiptContent',
    props: {
        receiptResults: {
            type: Object,
            required: true
        }
    },
    setup() {
        const store = useStore()

        const getLabel = (labelKey) =>
            store.getters['labels/getLabel']({
                labelCollection: 'receiptContent',
                labelKey: labelKey,
                allowEmpty: true
            })

        const src = ref('ReceiptPage.html')

        onMounted(() => {
            sessionStorage.removeItem('checkoutState')
        })

        return {
            getLabel,
            print: () => window.print()
        }
    }
}
